class VideoResponser {
    constructor(video) {
        this.options = {
            video,
            breakpoints: { default: { src: video.getAttribute('data-src') } },
            autoplay: video.hasAttribute('data-autoplay'),
        };

        video.querySelectorAll('[data-src]').forEach((element) => {
            this.options.breakpoints[element.getAttribute('data-mw')] = { src: element.getAttribute('data-src') };
        });
        video.innerHTML = '';

        this.responseVideo(this.options);
        this.resizer();
    }

    resizer() {
        window.addEventListener('resize', () => this.responseVideo(this.options));
    }

    responseVideo(options) { // eslint-disable-line class-methods-use-this
        const { video, breakpoints, autoplay } = options;
        const widthNow = video.getAttribute('data-width-now') || null;

        // Get all numeric breakpoints
        const numericBreakpoints = Object.keys(breakpoints)
            .filter((key) => key !== 'default')
            .map(Number);

        // Find the minimum breakpoint that's greater than current width
        const minBreakpoint = Math.min(...numericBreakpoints
            .filter((key) => key > document.body.clientWidth));

        // If no breakpoint is greater than current width, use default
        const nowBreakpoint = (minBreakpoint && minBreakpoint !== Infinity) ? minBreakpoint : 'default';

        // check if the video needs to be changed
        if (widthNow && widthNow === nowBreakpoint) return;

        video.setAttribute('data-width-now', nowBreakpoint);
        video.src = breakpoints[nowBreakpoint].src;
        video.load(); // Ensure the video reloads with the new source

        if (autoplay) {
            video.play().catch((error) => {
                console.warn('Autoplay failed:', error);
            });
        }
    }
}

export default VideoResponser;
